import { useState, useEffect } from "react";
import Nav from "../Nav";
import Footer from "../Footer";
import "../styles/user-management.scss";
import { Button } from "@mui/material";
import Modal from "@mui/material/Modal";
import AddIcon from "@mui/icons-material/Add";
import AddUserModal from "./AddUserModal";
import { getAllUsers, getUserAccessLevels } from "../../utils/utilsAPI";
import IndvUser from "./IndvUser";
import RefreshIcon from "@mui/icons-material/Refresh";
import { decryptData } from "../../utils/cryptoUtils";
import Loader from "../Loader";

export default function UserManagement() {
  //Users
  const [usersFixed, setUsersFixed] = useState([]);
  const [usersDisplayed, setUsersDisplayed] = useState([]);
  const [accessLevels, setAccessLevels] = useState([]);
  //Search
  const [searchedUsername, setSearchedUsername] = useState("");
  //Modals
  const [openAddUser, setOpenAddUser] = useState(false);
  //Reload & Loader
  const [reload, setReload] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    //Begin Loaders
    setLoader(true);
    //Get user access levels
    getUserAccessLevels().then((res) => {
      setAccessLevels(res.accessLevels);
    });
    //Get Users
    getAllUsers()
      .then((res) => {
        let _users = res.users;
        let decryptedData = _users.map((u, i) => {
          return {
            ...u,
            email: decryptData(u.email, process.env.REACT_APP_ATT_KEY),
          };
        });

        setUsersFixed(decryptedData);
        setUsersDisplayed(decryptedData);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
      });
  }, [reload]);

  const refreshUsers = () => {
    setReload(!reload);
  };

  const resetUsers = () => {
    setUsersDisplayed(usersFixed);
    setSearchedUsername("");
  };

  const handleSearch = (name) => {
    setSearchedUsername(name);
    let filteredUsers = usersFixed.filter((user) => {
      let _username = user.userName.toLowerCase();
      let _email = user.email.toLowerCase();

      return (
        _username.includes(name.toLowerCase()) ||
        _email.includes(name.toLowerCase())
      );
    });

    setUsersDisplayed(filteredUsers);
  };

  return (
    <>
      <Nav />
      <main className="user-management">
        <h1 className="page-header">
          User Management {` - ${localStorage.getItem("username")}`}
        </h1>
        <section className="user-content">
          <section className="search-section">
            <input
              placeholder="Search by username or email"
              type="text"
              onChange={(e) => handleSearch(e.target.value)}
              maxLength={50}
              value={searchedUsername}
            />
          </section>
          <section className="users-table-container">
            <div className="header-btns">
              <Button color="warning" variant="contained" onClick={resetUsers}>
                <RefreshIcon fontSize="large" />
              </Button>
              <Button
                className="add-user-btn"
                variant="contained"
                onClick={() => setOpenAddUser(true)}
              >
                <AddIcon fontSize="large" />
              </Button>
            </div>

            {!loader ? (
              usersDisplayed.length > 0 ? (
                <table className="users-table">
                  <thead>
                    <tr>
                      <th>Username</th>
                      <th>Email</th>
                      <th>User Level</th>
                      <th>Reset</th>
                      <th>Edit</th>
                      <th>Delete</th>
                      <th>Logs</th>
                    </tr>
                  </thead>
                  <tbody>
                    {usersDisplayed.length > 0
                      ? usersDisplayed.map((user, i) => {
                          return (
                            <IndvUser
                              key={i}
                              user={user}
                              accessLevels={accessLevels}
                              refreshUsers={refreshUsers}
                            />
                          );
                        })
                      : null}
                  </tbody>
                </table>
              ) : (
                <h2>No Users Found</h2>
              )
            ) : (
              <Loader />
            )}
          </section>
        </section>
      </main>
      <Footer />
      {/* MODALS */}
      <Modal open={openAddUser}>
        <AddUserModal
          accessLevels={accessLevels}
          setOpenAddUser={setOpenAddUser}
          refreshUsers={refreshUsers}
        />
      </Modal>
    </>
  );
}
